module.exports = __webpack_public_path__ + "static/img/bg.bf583ce.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/bg.jpg
// module id = n5qu
// module chunks = 1